(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/play/leia/event-handler.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/play/leia/event-handler.js');
"use strict";

var _svs$ticketUtility$da;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  GAME_LOADERS: {
    NEO_RGS
  }
} = svs.ticketgames.ticketUtility.utils.constants.leia;
const {
  neo
} = svs.ticketUtility && ((_svs$ticketUtility$da = svs.ticketUtility.data) === null || _svs$ticketUtility$da === void 0 ? void 0 : _svs$ticketUtility$da.gameloaderHelperConfig) || {};

const neoOrigin = (neo === null || neo === void 0 ? void 0 : neo.url) && new URL(neo.url).origin;

const GAME_LOADING = 'GAME_LOADING';
const GAME_LOADING_COMPLETED = 'GAME_LOADING_COMPLETED';
const HAS_CLAIMED = 'HAS_CLAIMED';
const HAS_BET = 'HAS_BET';
const PREBET = 'PREBET';
const HANDLE_PREBET = 'HANDLE_PREBET';
const TAG = 'TAG';
const SOUND_STATUS = 'SOUND_STATUS';
const OPEN_POPUP = 'OPEN_POPUP';

const GAME_LOADING_FINISHED = 'GAME_LOADING_FINISHED';
const postMessage = (data, origin) => {
  var _gameloaderHelper$ins;
  svs.eInstant.logger.debug("Sending message: ".concat(JSON.stringify(data)));
  (_gameloaderHelper$ins = gameloaderHelper.instance) === null || _gameloaderHelper$ins === void 0 || _gameloaderHelper$ins.bridgeWindow.postMessage(data, origin);
};
const rgsNEO = events => {
  const allowedOrigins = [neoOrigin, location.origin];
  const eventsToReplace = {
    [HANDLE_PREBET]: {
      eventName: PREBET,
      handler: handler => data => {
        const handle = accept => () => postMessage({
          type: PREBET,
          data: {
            accept
          }
        }, neoOrigin);
        handler({
          detail: _objectSpread(_objectSpread({}, data.detail), {}, {
            delay: 2000,
            resolve: handle(true),
            reject: handle(false)
          })
        });
      }
    },
    [SOUND_STATUS]: {
      eventName: SOUND_STATUS,
      handler: handler => data => {
        var _data$detail;
        handler({
          detail: data === null || data === void 0 || (_data$detail = data.detail) === null || _data$detail === void 0 ? void 0 : _data$detail.soundOn
        });
      }
    },
    [GAME_LOADING]: {
      eventName: GAME_LOADING_COMPLETED,
      handler: handler => () => {
        handler();
      }
    }
  };
  const customEvents = [{
    eventName: OPEN_POPUP,
    handler: data => {
      var _detail$popup;
      const {
        detail
      } = data;
      svs.eInstant.logger.debug("NEO: Received OPEN_POPUP event with data: ".concat(JSON.stringify(detail)));
      if ((detail === null || detail === void 0 || (_detail$popup = detail.popup) === null || _detail$popup === void 0 ? void 0 : _detail$popup.level) === 'error') {
        svs.ticketgames.ticketUtility.utils.handleOpenPopError(detail, () => {});
      }
    }
  }];
  events = [...events, ...customEvents].map(e => {
    var _eventsToReplace$e$ev, _eventsToReplace$e$ev2;
    return {
      eventName: ((_eventsToReplace$e$ev = eventsToReplace[e.eventName]) === null || _eventsToReplace$e$ev === void 0 ? void 0 : _eventsToReplace$e$ev.eventName) || e.eventName,
      handler: ((_eventsToReplace$e$ev2 = eventsToReplace[e.eventName]) === null || _eventsToReplace$e$ev2 === void 0 ? void 0 : _eventsToReplace$e$ev2.handler(e.handler)) || e.handler
    };
  });
  const eventHandler = event => {
    var _eventData;
    if (!allowedOrigins.includes(event.origin)) {
      svs.eInstant.logger.warn('Unknown origin:', event.origin);
      return;
    }
    let eventData = event === null || event === void 0 ? void 0 : event.data;
    if (typeof eventData === 'string') {
      eventData = JSON.parse(eventData);
    }
    const eventType = (_eventData = eventData) === null || _eventData === void 0 || (_eventData = _eventData.data) === null || _eventData === void 0 ? void 0 : _eventData.type;
    const handlers = events.filter(evt => evt.eventName === eventType);
    if (handlers.length > 0) {
      svs.eInstant.logger.debug("Handlers found for event: ".concat(eventType));
      handlers.forEach(handler => handler.handler({
        detail: _objectSpread({}, eventData.data)
      }));
    } else {
      svs.eInstant.logger.debug("No handler found for event: ".concat(JSON.stringify(eventData)));
    }
  };
  const initialize = () => window.addEventListener('message', eventHandler);
  const destroy = () => window.removeEventListener('message', eventHandler);
  return {
    initialize,
    destroy
  };
};
const eventHandler = (gameLoader, events) => {
  switch (gameLoader) {
    case NEO_RGS:
      return rgsNEO(events);
    default:
      return {
        initialize: () => events.forEach(evt => addEventListener(evt.eventName, evt.handler)),
        destroy: () => events.forEach(evt => removeEventListener(evt.eventName, evt.handler))
      };
  }
};
setGlobal('svs.eInstant.lobby.play.leia.eventHandler', eventHandler);
setGlobal('svs.eInstant.lobby.play.leia', {
  customNotifiers: {
    soundStatus: {
      [NEO_RGS]: soundOn => postMessage({
        type: SOUND_STATUS,
        detail: {
          soundOn
        }
      }, neoOrigin)
    }
  },
  ticketEvents: {
    GAME_LOADING,
    GAME_LOADING_FINISHED,
    HAS_CLAIMED,
    HAS_BET,
    PREBET,
    HANDLE_PREBET,
    TAG,
    SOUND_STATUS,
    OPEN_POPUP
  }
});

 })(window);